import React from 'react';
import { Amplify } from 'aws-amplify';
import { BrowserRouter as Router } from 'react-router-dom';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports';
import { NotificationContainer } from 'react-notifications';

import NavBar from './Components/NavBar';
import { getRoutes } from './Components/RoutesConfigs';
import { ErrorBoundary } from './Components/ErrorBoundary';

Amplify.configure(awsExports);

function App({ signOut, user }) {
	return (
		<Router>
			<NavBar />
			<div className="grid justify-items-center">
				<div className="w-4/5">
					<NotificationContainer />
					<div>
						<ErrorBoundary>
							{getRoutes()}

						</ErrorBoundary>
					</div>
				</div>
			</div>
		</Router>
	);
}

export default withAuthenticator(App, { hideSignUp: true });
